module.exports = __webpack_public_path__ + "static/media/d1.71887b3a.jpg";